export default "__VITE_ASSET__d881f9b4__"